@if (isLoading()) {
  <div class="cb-page-loader">
    <cb-loader></cb-loader>
    @if (loadingText() && loadingText().length>0) {
      <p>{{loadingText() | translate}}</p>
    }
  </div>
} @else {
  <ng-content></ng-content>
}
